import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

export enum ComplaintState {
  NONE = 0, // 未投诉
  UNTREATED=2, // 未处理
  UNDERWAY=5, // 进行中
  COMPLETED=8 // 已完成
}

export interface IComplaintItem {
  id: number,
  stage: ComplaintState
}

@Module({ dynamic: true, store, name: 'complaint' })
class Complaint extends VuexModule {
  public list:IComplaintItem[] = [];

  @Mutation
  private ADD_TO_LIST(data: IComplaintItem) {
    this.list.push(data);
  }

  @Mutation
  private REMOVE_FROM_LIST(id: number) {
    this.list = this.list.filter(item => item.id !== id);
  }

  @Action
  /**
   * addItem
   */
  public addItem(data: IComplaintItem) {
    this.ADD_TO_LIST(data);
  }

  @Action
  /**
   * removeItem
   */
  public removeItem(id: number) {
    this.REMOVE_FROM_LIST(id);
  }

  @Action
  /**
   * switchStage
   */
  public switchStage(data: IComplaintItem) {
    this.REMOVE_FROM_LIST(data.id);
    this.ADD_TO_LIST(data);
  }
}

export const ComplaintModule = getModule(Complaint);
